export interface Alert_Interface {
    id: number,
    user_id: number,
    code: String,
    title: String,
    message: string,
    customer: boolean,
    giver: String,
    persianData: String,
    expirationData: String,
    username: String,
    del:boolean,
    files: Array<string>,
}

export function Empty_Alert_Interface():Alert_Interface{
    return{
      id:0,
      user_id:0,
      code:'',
      message:'',
      title:'',
      giver:'',
      customer:false,
      del:false,
      persianData:'',
      expirationData:'',
      username:'',
      files:[]
    }
  }
